import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M1 23 15.667 8.333m-5.134 0h-2.2m14.667 0h-2.2m0-5.133-1.556 1.556M15.667 3.2V1m0 14.667v-2.2m-3.578-8.711L10.533 3.2M20.8 13.467l-1.556-1.556" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
